import Vue from 'vue'
import Vuex from 'vuex'
import statisticsService from '../api/statistics'

Vue.use(Vuex)

const initialState = {
  statistics: [],
}

const getters = {
  statistics(state) {
    return state.statistics
  }
}

export const actions = {
  async getStatisticByPersonId(context, payload) {
    try {
      const response = await statisticsService.getStatisticByPersonId(payload);
      context.state.statistics = response.data.statistics
      return Promise.resolve();
    } catch (error) {
      const errorMessage = context.rootState.langObj.response.error[error.response.data] || context.rootState.langObj.response.error.somethingWentWrong;
      context.commit('toast', { message: errorMessage, color: 'red lighten-2' }, { root: true });
      return Promise.reject(error);
    }
  },
  async insertStatistic(context, payload) {
    try {
      const response = await statisticsService.insertStatistic(payload);
      return Promise.resolve();
    } catch (error) {
      const errorMessage = context.rootState.langObj.response.error[error.response.data] || context.rootState.langObj.response.error.somethingWentWrong;
      context.commit('toast', { message: errorMessage, color: 'red lighten-2' }, { root: true });
      return Promise.reject(error);
    }
  }
}

export const state = { ...initialState }

export default {
  namespaced: true,
  state,
  getters,
  actions
}
